import React from 'react'
import PropTypes from 'prop-types'

export default function DieselTracksTextBlock({ section }) {
  return (
    <section
      id="DieselTracksAbout"
      className="diesel-tracks__section diesel-tracks__text-block"
      key={section.strapi_component}>
      <div className="diesel-tracks__text-block-wrapper">
        <h2 className="diesel-tracks-font-primary diesel-tracks-heading diesel-tracks__text-block-heading">
          {section.heading}
        </h2>
        <div
          className="diesel-tracks-font-primary diesel-tracks__paragraph"
          dangerouslySetInnerHTML={{ __html: section.body.replace(/\n/g, '<br />') }} />
      </div>
    </section>
  )
}

DieselTracksTextBlock.propTypes = {
  section: PropTypes.object,
}
